import PropTypes from "prop-types";
import React, { Component } from "react";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import StepContent from "./wizard/StepContent";
import {
  closeMainDialog,
  deleteSubStep,
  nextStep,
  setActiveStep,
  setDisableBtn,
  setReturnedValue,
  showBtnNext,
  showFaq,
  showFooterContinue
} from "../actions";
import { connect } from "react-redux";
import Footer from "../containers/Footer";
import {
  goToBeginning,
  searchSelfRemoveSubStep,
  searchStep
} from "../utils/scenario-manager";
import Breadcrumbs from "./Breadcrumbs";
import breadcrumbs from "../utils/breadcrumbs";
import { GROUP_QUESTION_RESPONSE, STEP_SEPARATOR } from "../utils/constants";
import { Trans } from "@lingui/macro";
import {
  getCurrentStep,
  getFirstStepNotBypassed,
  logOut,
  switchWidgetPatientArea,
  verifiedCodeReset
} from "../utils/fetcher";
import LocaleSwitcher from "./LocaleSwitcher";
import { translator } from "../utils/i18n";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MenuAppBar from "./MenuAppBar";
import CloseIcon from "@material-ui/icons/Close";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import ConfirmCancelAppointment from "./ConfirmCancelAppointment";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import { initValues } from "../utils/fetcher";
import ConnexionPatientArea from "../app/patient-area/ConnexionPatientArea";
let mode = "";
const queryParams = new URLSearchParams(window.location.search);
const Id = queryParams.get("id")?.split("_");
class Wizard extends Component {
  state = {
    showConfirmCancelAppointment: false,
    actionConfirmCancelAppointment: "",
    response: "",
    isValid: 0
  };

  goToPreviousStep = () => {
    if (getCurrentStep().step >= 2) {
      this.setState({ showConfirmCancelAppointment: true });
      this.setState({ actionConfirmCancelAppointment: this.previousStep });
    } else {
      this.previousStep();
    }
  };

  verifiedCode = (code, userId) => {
    this.props.verifiedCode(
      { code: code, identifiant_user: userId, idc: initValues().idc },
      (message, success) => {
        this.setState({
          response: message,
          isValid: success === "erreur" ? false : true
        });
      }
    );
  };

  componentDidMount() {
    this.mode();
  }

  mode = () => {
    const currentPath = window.location.href;
    if (currentPath.includes("/mdpmodif")) {
      this.verifiedCode(Id[1], Id[0]);
      mode = "mdpmodif";
      return "mdpmodif";
    }
    mode = "rdv";
    return "rdv";
  };

  previousStep = () => {
    this.props.showBtnNextFun(false);
    const { activeStep, steps } = this.props;
    const currentActiveStep = { ...activeStep };
    const backStep = () => {
      activeStep.step -= 1;
      if (steps[activeStep.step].children.length > 0) {
        activeStep.subStep = steps[activeStep.step].children.length - 1;
      }
    };

    if (steps[activeStep.step].children.length > 0) {
      if (activeStep.subStep >= 1) {
        activeStep.subStep -= 1;
      } else {
        backStep();
      }
    } else {
      backStep();
    }
    this.props.setActiveStep(activeStep);
    this.props.updateBreadcrumbs(currentActiveStep, activeStep);
    this.isValid(false);

    this.props.setReturnedValue({ isRewind: true });

    const destStep = searchStep(steps, activeStep);
    if (destStep) {
      if (destStep.stepper.previous) {
        Array.from(Array(destStep.stepper.previous).keys()).forEach(() =>
          this.previousStep()
        );
      } else if (destStep.byPass) {
        this.previousStep();
      }
      const fromStep = searchStep(steps, currentActiveStep);
      if (fromStep) {
        let subStepToRemove = {};
        if (
          fromStep.selfRemove.group &&
          !destStep.selfRemove.group &&
          fromStep.selfRemove.group !== GROUP_QUESTION_RESPONSE
        ) {
          subStepToRemove = searchSelfRemoveSubStep(
            steps,
            fromStep.selfRemove.group
          );
        }
        for (const key in subStepToRemove) {
          if (Object.prototype.hasOwnProperty.call(subStepToRemove, key)) {
            const [stepIndex, subStepIndex] = key.split(STEP_SEPARATOR);
            this.props.deleteSubStep(+stepIndex, +subStepIndex);
          }
        }
      }
    }
  };

  prepareSteps = (steps, activeStep) => {
    const _stepsContent = [];
    const _stepsLabel = [];
    for (const stepKey in steps) {
      if (Object.prototype.hasOwnProperty.call(steps, stepKey)) {
        const step = steps[stepKey];
        const isActiveStep = activeStep.step === +stepKey;

        _stepsLabel.push(
          <Step
            className={
              isActiveStep ? "item-step wrap-active-step" : "item-step"
            }
            key={stepKey}
          >
            <StepLabel
              className={isActiveStep ? "active-step" : "inactive-step"}
            >
              {step.label}
            </StepLabel>
          </Step>
        );

        _stepsContent.push(
          <StepContent
            key={`${stepKey}-content`}
            isValid={this.isValid}
            activeSubStep={activeStep.subStep}
            step={step}
            active={isActiveStep}
          />
        );
      }
    }
    return { stepsLabel: _stepsLabel, stepsContent: _stepsContent };
  };

  isValid = (stateBtn = false) => {
    if (stateBtn) {
      this.props.nextStep(this.props.steps);
      this.props.showBtnNextFun(false);
    }
    this.props.setDisableBtn();
  };

  showPopinFaq = () => {
    this.props.showFaq(true);
  };

  closeMainDialog = () => {
    if (getCurrentStep().step >= 2 && getCurrentStep().step !== 3) {
      this.setState({ showConfirmCancelAppointment: true });
      this.setState({
        actionConfirmCancelAppointment: this.actionCancelAppointment
      });
    } else if (getCurrentStep().step === 3) {
      this.actionCancelAppointment();
      this.props.goToBeginning();
    } else {
      this.actionCancelAppointment();
      this.props.closeMainDialog();
    }
  };

  goToPreviousPath = () => {
    window.location.href = document.referrer;
  };

  toggleCancelAppointment = isOpen => {
    this.setState({ showConfirmCancelAppointment: isOpen });
  };

  actionCancelAppointment = () => {
    window.parent.postMessage({ event_id: "closeiframe" }, "*");
  };

  breadcrumbsCancelAppointment = (action, isShowCancelAppointment) => {
    this.setState({ actionConfirmCancelAppointment: action });
    this.setState({ showConfirmCancelAppointment: isShowCancelAppointment });
  };

  logoutFunc = () => {
    if (getCurrentStep().step >= 2 && getCurrentStep().step !== 3) {
      this.setState({ showConfirmCancelAppointment: true });
      this.setState({
        actionConfirmCancelAppointment: this.logoutAction
      });
    } else if (getCurrentStep().step === 3) {
      this.props.logOut();
      this.props.goToBeginning();
    } else {
      this.props.logOut();
    }
  };

  logoutAction = () => {
    this.props.logOut();
    this.props.goToBeginning();
  };

  switchWidgetPatientAreaFunc = () => {
    if (getCurrentStep().step >= 2 && getCurrentStep().step !== 3) {
      this.setState({ showConfirmCancelAppointment: true });
      this.setState({
        actionConfirmCancelAppointment: this.props.switchWidgetPatientArea
      });
    } else {
      this.props.switchWidgetPatientArea();
    }
  };

  render() {
    const {
      steps,
      activeStep,
      enableBtn,
      isOpenSideBar,
      toggleSideBar,
      user
    } = this.props;
    const isShowLanguage = this.props.isShowLang || false;
    const { stepsLabel, stepsContent } = this.prepareSteps(steps, activeStep);
    const userData = user.userData;
    const isLoggedIn = Object.keys(userData).length > 0;
    const { step, subStep } = getFirstStepNotBypassed();
    const actions = [];
    const noClose = initValues().noClose;

    if (isLoggedIn) {
      actions.push(
        {
          icon: <LockOpenIcon />,
          name: translator()._("W_STEP_BOUTON_DECONNECTER"),
          action: this.logoutFunc
        },
        {
          icon: <AccountCircleIcon />,
          name: translator()._("CP_TITLE"),
          action: this.switchWidgetPatientAreaFunc
        }
      );
    }

    const isFirstStep = () =>
      step === activeStep.step && subStep === activeStep.subStep;
    return (
      <>
        {mode === "mdpmodif" ? (
          <ConnexionPatientArea
            state={this.state.isValid ? "reinitialized" : "expired"}
            idUser={Id[0]}
            code={Id[1]}
          />
        ) : (
          <div className="wrap-page">
            <div className="wrap-nav">
              <Stepper
                className="no-bg wrap-stepper"
                activeStep={activeStep.step}
              >
                {stepsLabel}
              </Stepper>
              {!noClose && (
                <button
                  className="no-style-btn"
                  onClick={this.goToPreviousPath}
                  name={translator()._("W_STEP_BOUTON_FERMER")}
                >
                  <CloseIcon color="primary" />
                </button>
              )}
            </div>
            {Object.keys(this.props.itemBreadcrumbs).length !== 0 && (
              <Breadcrumbs
                breadcrumbsCancelAppointment={(action, isShow) =>
                  this.breadcrumbsCancelAppointment(action, isShow)
                }
                itemsBreadcrumbs={this.props.itemBreadcrumbs}
              />
            )}
            <div className="wrap-content-step">{stepsContent}</div>
            <Footer
              enableBtn={enableBtn}
              isFirstStep={isFirstStep()}
              steps={steps}
              previousStep={this.goToPreviousStep}
              showBtnNext={this.props.showFooterContinue}
            />

            {this.props.isFromAdmin !== "admin" && (
              <div className="wrap-navbar-right">
                <div className="wrap-menu">
                  {isLoggedIn && (
                    <div className="user">
                      <Trans id="W_BONJOUR" />{" "}
                      <strong className="primary">{userData.lastName}</strong>
                    </div>
                  )}
                  {isShowLanguage && isFirstStep() && <LocaleSwitcher />}
                  <Tooltip
                    color="primary"
                    title={translator()._("W_AIDE")}
                    placement="top"
                  >
                    <Fab
                      onClick={this.showPopinFaq}
                      color="primary"
                      aria-label={translator()._("W_FAQ")}
                      size="small"
                      className="mr-6"
                    >
                      <span className="size-2em">?</span>
                    </Fab>
                  </Tooltip>
                  {actions && actions.length === 0 && (
                    <Tooltip title={translator()._("CP_TITLE")} placement="top">
                      <Fab
                        onClick={this.switchWidgetPatientAreaFunc}
                        color="primary"
                        aria-label={translator()._("W_FAQ")}
                        size="small"
                        className="mr-6"
                      >
                        <AccountCircleIcon />
                      </Fab>
                    </Tooltip>
                  )}
                  {actions && actions.length > 0 && (
                    <MenuAppBar
                      actions={actions}
                      defaultAction={this.switchWidgetPatientAreaFunc}
                    />
                  )}
                  {this.props.configuration &&
                    this.props.configuration.infoSide &&
                    this.props.configuration.infoSide.length > 0 && (
                      <button
                        className="button-panel primary-bg"
                        onClick={toggleSideBar}
                      >
                        <img
                          src={
                            isOpenSideBar
                              ? "images/icon_btn_right_side_panel.svg"
                              : "images/icon_btn_left_side_panel.svg"
                          }
                          alt=""
                        />
                      </button>
                    )}
                </div>
              </div>
            )}
          </div>
        )}
        {this.state.showConfirmCancelAppointment && (
          <ConfirmCancelAppointment
            toggleDialog={isOpen => this.toggleCancelAppointment(isOpen)}
            isOpenDialog={this.state.showConfirmCancelAppointment}
            action={this.state.actionConfirmCancelAppointment}
          />
        )}
      </>
    );
  }
}

Wizard.propTypes = {
  activeStep: PropTypes.shape({
    step: PropTypes.any,
    subStep: PropTypes.number
  }),
  closeMainDialog: PropTypes.func,
  configuration: PropTypes.shape({
    infoSide: PropTypes.string
  }),
  deleteSubStep: PropTypes.func,
  enableBtn: PropTypes.any,
  goToBeginning: PropTypes.func,
  isFromAdmin: PropTypes.string,
  isOpenSideBar: PropTypes.bool,
  isShowLang: PropTypes.bool,
  itemBreadcrumbs: PropTypes.any,
  logOut: PropTypes.func,
  nextStep: PropTypes.func,
  setActiveStep: PropTypes.func,
  setDisableBtn: PropTypes.func,
  setReturnedValue: PropTypes.func,
  showBtnNextFun: PropTypes.func,
  showFaq: PropTypes.func,
  showFooterContinue: PropTypes.func,
  steps: PropTypes.any,
  switchWidgetPatientArea: PropTypes.func,
  toggleSideBar: PropTypes.func,
  updateBreadcrumbs: PropTypes.func,
  user: PropTypes.shape({
    userData: PropTypes.shape({
      lastName: PropTypes.string
    })
  }),
  verifiedCode: PropTypes.func
};

const mapStateToProps = state => {
  return {
    steps: state.steps,
    activeStep: state.activeStep,
    enableBtn: state.btnState,
    itemBreadcrumbs: state.itemBreadcrumbs,
    user: state.user,
    showBtnNext: state.showBtnNext,
    showFooterContinue: state.showFooterContinue,
    isShowLang: state.configuration.isShowLang || false,
    isFromAdmin: state.returnedValue.from,
    configuration: state.configurationo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setActiveStep: activeStep => dispatch(setActiveStep(activeStep)),
    setDisableBtn: disableBtn => dispatch(setDisableBtn(disableBtn)),
    nextStep: steps => {
      setReturnedValue({ isRewind: false });
      return dispatch(nextStep(steps));
    },
    verifiedCode: (values, success) =>
      dispatch(verifiedCodeReset(values, success)),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    deleteSubStep: (stepIndex, subStepIndex) =>
      dispatch(deleteSubStep(stepIndex, subStepIndex)),
    showFaq: isShow => dispatch(showFaq(isShow)),
    updateBreadcrumbs: (from, to) => dispatch(breadcrumbs(from, to)),
    closeMainDialog: () => dispatch(closeMainDialog()),
    showBtnNextFun: isShow => dispatch(showBtnNext(isShow)),
    showFooterContinue: isShow => dispatch(showFooterContinue(isShow)),
    logOut: () => dispatch(logOut()),
    switchWidgetPatientArea: () => dispatch(switchWidgetPatientArea()),
    goToBeginning: () => dispatch(goToBeginning())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Wizard);
